import SocketManager from "./socketManager.js";
import { io } from "socket.io-client";
import { config } from "dotenv";
import { RestaurantManager, ResidenceManager, ActualitesManager, ClientResourceManager } from "./classes/ResourceManagers/AllManagers.js";
import ClientSettings from "./classes/ClientSettings.js";
config();

const CROUS_API_URL = process.env.CROUS_API_URL ?? "https://apis.lerouxnard.fr/crous";

export class Client extends SocketManager {
	restaurant = new RestaurantManager();
	residence = new ResidenceManager();
	actualites = new ActualitesManager();

	constructor(settings: ClientSettings) {
		ClientResourceManager.setApiUrl(CROUS_API_URL);
		const { autoConnect, ...querySettings } = settings;
		const socket = io(CROUS_API_URL, { query: querySettings, autoConnect: autoConnect ?? false });
		super(socket);
		if (!socket.connected && autoConnect) {
			const timeout = setInterval(() => {
				if (socket.connected) {
					console.debug("Connected");
					clearInterval(timeout);
				} else {
					console.debug("Not connected")
					socket.connect();
				}
			}, 1000);
		}
	}
}

export * from "./classes/index.js";
